import React, { memo } from 'react';
import { LoadingIconContainer, PxCaptchaContainer } from "./PxCaptcha.styles";
import { LoadingIcon } from '@chegg-ui/horizon-icons';
var PxCaptcha = function PxCaptcha() {
  return /*#__PURE__*/React.createElement(PxCaptchaContainer, {
    "data-test": 'px-captcha'
  }, /*#__PURE__*/React.createElement("div", {
    id: "px-captcha"
  }), /*#__PURE__*/React.createElement(LoadingIconContainer, null, /*#__PURE__*/React.createElement(LoadingIcon, {
    size: "large"
  })));
};
export default /*#__PURE__*/memo(PxCaptcha);